import * as React from 'react';
import { ArticleDto } from '@/features/programs/model/types';
import { Article } from '@/features/programs/shared/ui/Article';
import { ExpandableGrid } from '@/features/programs/shared/ui/ExpandableGrid';

const articleGridClassName =
    'grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-4 justify-center gap-4 transition-[max-height] duration-500 ease-in-out';

type ArticlesGridProps = {
    articles: ArticleDto[];
    backgroundColor?: string;
};

export const ArticlesGrid: React.FC<ArticlesGridProps> = ({
    articles = [],
    backgroundColor,
}) => (
    <ExpandableGrid
        items={articles}
        gridClassName={articleGridClassName}
        backgroundColor={backgroundColor}
    >
        {({ items, isCoveredByOverlay }) =>
            items.map((article, index) => (
                <Article
                    key={article.url}
                    article={article}
                    isCoveredByOverlay={isCoveredByOverlay(index)}
                />
            ))
        }
    </ExpandableGrid>
);
